import styled from '@emotion/styled';

/* ── styled components ── */

const Section = styled.section`
	background-color: white;
	color: black;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem;
	@media (min-width: 640px) {
		& > * + * {
			margin-left: 1rem;
		}
	}
	@media (max-width: 639px) {
		flex-direction: column-reverse;
	}
`;

const BrandingBlock = styled.div`
	align-items: flex-start;
	@media (min-width: 640px) {
		display: flex;
		& > * + * {
			margin-left: 1rem;
		}
	}
	@media (max-width: 639px) {
		padding-top: 2rem;
	}
`;

const PoweredLabel = styled.div`
	font-size: 0.75rem;
	line-height: 1rem;
	color: #6b7280;
	text-align: center;
	@media (max-width: 639px) {
		padding-bottom: 0.5rem;
	}
`;

const TenantLogo = styled.img`
	height: 4rem;
`;

export default function PoweredBlockEta({ tenantLogo }: { tenantLogo: string }) {
	return (
		<Section>
			<BrandingBlock>
				<PoweredLabel>powered by</PoweredLabel>
				<TenantLogo src={tenantLogo} />
			</BrandingBlock>
		</Section>
	);
}
